// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  ApierrorsError,
  RequestEnvironment,
  RequestEnvironmentEvent,
  RequestEnvironmentOperation,
  RequestEnvironmentSpecCluster,
  RequestEnvironmentSpecComponent,
  RequestOwnerIdentifier,
  RequestScaleUp,
  ResponseDiffReport,
  ResponseEnvironment,
  ResponseEnvironmentConfig,
  ResponseEnvironmentCreated,
  ResponseEnvironmentList,
  ResponseEnvironmentStatusOperation,
  ResponseOpCreated,
  ServerRequestComponentList,
} from '../models/index';
import {
  ApierrorsErrorFromJSON,
  ApierrorsErrorToJSON,
  RequestEnvironmentFromJSON,
  RequestEnvironmentToJSON,
  RequestEnvironmentEventFromJSON,
  RequestEnvironmentEventToJSON,
  RequestEnvironmentOperationFromJSON,
  RequestEnvironmentOperationToJSON,
  RequestEnvironmentSpecClusterFromJSON,
  RequestEnvironmentSpecClusterToJSON,
  RequestEnvironmentSpecComponentFromJSON,
  RequestEnvironmentSpecComponentToJSON,
  RequestOwnerIdentifierFromJSON,
  RequestOwnerIdentifierToJSON,
  RequestScaleUpFromJSON,
  RequestScaleUpToJSON,
  ResponseDiffReportFromJSON,
  ResponseDiffReportToJSON,
  ResponseEnvironmentFromJSON,
  ResponseEnvironmentToJSON,
  ResponseEnvironmentConfigFromJSON,
  ResponseEnvironmentConfigToJSON,
  ResponseEnvironmentCreatedFromJSON,
  ResponseEnvironmentCreatedToJSON,
  ResponseEnvironmentListFromJSON,
  ResponseEnvironmentListToJSON,
  ResponseEnvironmentStatusOperationFromJSON,
  ResponseEnvironmentStatusOperationToJSON,
  ResponseOpCreatedFromJSON,
  ResponseOpCreatedToJSON,
  ServerRequestComponentListFromJSON,
  ServerRequestComponentListToJSON,
} from '../models/index';

export interface ComponentsPostRequest {
  owners: ServerRequestComponentList;
}

export interface V3EnvironmentsByNameEnvironmentNameGetRequest {
  environmentName: string;
  includeStatusHistory?: boolean;
}

export interface V3EnvironmentsEnvironmentIDClustersPostRequest {
  environmentID: string;
  clusters: Array<RequestEnvironmentSpecCluster>;
  dispatchOption?: V3EnvironmentsEnvironmentIDClustersPostDispatchOptionEnum;
}

export interface V3EnvironmentsEnvironmentIDComponentsPostRequest {
  environmentID: string;
  components: Array<RequestEnvironmentSpecComponent>;
  dispatchOption?: V3EnvironmentsEnvironmentIDComponentsPostDispatchOptionEnum;
}

export interface V3EnvironmentsEnvironmentIDConfigGetRequest {
  environmentID: string;
  stripIdentifiers?: boolean;
}

export interface V3EnvironmentsEnvironmentIDDeleteRequest {
  environmentID: string;
  dispatchOption?: V3EnvironmentsEnvironmentIDDeleteDispatchOptionEnum;
}

export interface V3EnvironmentsEnvironmentIDEventsPostRequest {
  environmentID: string;
  owners: RequestEnvironmentEvent;
}

export interface V3EnvironmentsEnvironmentIDGetRequest {
  environmentID: string;
  includeStatusHistory?: boolean;
}

export interface V3EnvironmentsEnvironmentIDOperationsOperationIDGetRequest {
  environmentID: string;
  operationID: number;
}

export interface V3EnvironmentsEnvironmentIDOperationsOperationIDPutRequest {
  environmentID: string;
  operationID: number;
  owners: RequestEnvironmentOperation;
}

export interface V3EnvironmentsEnvironmentIDOwnersOwnerRefIDDeleteRequest {
  environmentID: string;
  ownerRefID: number;
}

export interface V3EnvironmentsEnvironmentIDOwnersPostRequest {
  environmentID: string;
  owners: Array<RequestOwnerIdentifier>;
}

export interface V3EnvironmentsEnvironmentIDOwnersPutRequest {
  environmentID: string;
  owners: Array<RequestOwnerIdentifier>;
}

export interface V3EnvironmentsEnvironmentIDPutRequest {
  environmentID: string;
  environment: RequestEnvironment;
  dispatchOption?: V3EnvironmentsEnvironmentIDPutDispatchOptionEnum;
}

export interface V3EnvironmentsEnvironmentIDScaleDownPostRequest {
  environmentID: string;
}

export interface V3EnvironmentsEnvironmentIDScaleUpPostRequest {
  environmentID: string;
  duration: RequestScaleUp;
}

export interface V3EnvironmentsEnvironmentIDUpdatePostRequest {
  environmentID: string;
  dispatchOption?: V3EnvironmentsEnvironmentIDUpdatePostDispatchOptionEnum;
}

export interface V3EnvironmentsGetRequest {
  searchTerm?: string;
  ownerIdentifier?: string;
  includeDeleted?: boolean;
}

export interface V3EnvironmentsIdByNameEnvironmentNameGetRequest {
  environmentName: string;
}

export interface V3EnvironmentsNamesGetRequest {
  searchTerm?: string;
  ownerIdentifier?: string;
}

export interface V3EnvironmentsPostRequest {
  environment: RequestEnvironment;
  dispatchOption?: V3EnvironmentsPostDispatchOptionEnum;
}

/**
 *
 */
export class EnvironmentApi extends runtime.BaseAPI {
  /**
   * Stores the components as published in the components view.
   * Stores the components as published in the components view.
   */
  async componentsPostRaw(
    requestParameters: ComponentsPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['owners'] == null) {
      throw new runtime.RequiredError(
        'owners',
        'Required parameter "owners" was null or undefined when calling componentsPost().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/components`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ServerRequestComponentListToJSON(requestParameters['owners']),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Stores the components as published in the components view.
   * Stores the components as published in the components view.
   */
  async componentsPost(
    requestParameters: ComponentsPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.componentsPostRaw(requestParameters, initOverrides);
  }

  /**
   * Get an environment by name
   * Get an environment by name
   */
  async v3EnvironmentsByNameEnvironmentNameGetRaw(
    requestParameters: V3EnvironmentsByNameEnvironmentNameGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseEnvironment>> {
    if (requestParameters['environmentName'] == null) {
      throw new runtime.RequiredError(
        'environmentName',
        'Required parameter "environmentName" was null or undefined when calling v3EnvironmentsByNameEnvironmentNameGet().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['includeStatusHistory'] != null) {
      queryParameters['include_status_history'] =
        requestParameters['includeStatusHistory'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/v3/environments/by-name/{environmentName}`.replace(
          `{${'environmentName'}}`,
          encodeURIComponent(String(requestParameters['environmentName'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseEnvironmentFromJSON(jsonValue),
    );
  }

  /**
   * Get an environment by name
   * Get an environment by name
   */
  async v3EnvironmentsByNameEnvironmentNameGet(
    requestParameters: V3EnvironmentsByNameEnvironmentNameGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseEnvironment> {
    const response = await this.v3EnvironmentsByNameEnvironmentNameGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Add clusters to an environment
   * Add clusters to environment
   */
  async v3EnvironmentsEnvironmentIDClustersPostRaw(
    requestParameters: V3EnvironmentsEnvironmentIDClustersPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseOpCreated>> {
    if (requestParameters['environmentID'] == null) {
      throw new runtime.RequiredError(
        'environmentID',
        'Required parameter "environmentID" was null or undefined when calling v3EnvironmentsEnvironmentIDClustersPost().',
      );
    }

    if (requestParameters['clusters'] == null) {
      throw new runtime.RequiredError(
        'clusters',
        'Required parameter "clusters" was null or undefined when calling v3EnvironmentsEnvironmentIDClustersPost().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['dispatchOption'] != null) {
      queryParameters['dispatchOption'] = requestParameters['dispatchOption'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/v3/environments/{environmentID}/clusters`.replace(
          `{${'environmentID'}}`,
          encodeURIComponent(String(requestParameters['environmentID'])),
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters['clusters']!.map(
          RequestEnvironmentSpecClusterToJSON,
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseOpCreatedFromJSON(jsonValue),
    );
  }

  /**
   * Add clusters to an environment
   * Add clusters to environment
   */
  async v3EnvironmentsEnvironmentIDClustersPost(
    requestParameters: V3EnvironmentsEnvironmentIDClustersPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseOpCreated | null | undefined> {
    const response = await this.v3EnvironmentsEnvironmentIDClustersPostRaw(
      requestParameters,
      initOverrides,
    );
    switch (response.raw.status) {
      case 200:
        return await response.value();
      case 204:
        return null;
      default:
        return await response.value();
    }
  }

  /**
   * Add components to an environment
   * Add components to environment
   */
  async v3EnvironmentsEnvironmentIDComponentsPostRaw(
    requestParameters: V3EnvironmentsEnvironmentIDComponentsPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseOpCreated>> {
    if (requestParameters['environmentID'] == null) {
      throw new runtime.RequiredError(
        'environmentID',
        'Required parameter "environmentID" was null or undefined when calling v3EnvironmentsEnvironmentIDComponentsPost().',
      );
    }

    if (requestParameters['components'] == null) {
      throw new runtime.RequiredError(
        'components',
        'Required parameter "components" was null or undefined when calling v3EnvironmentsEnvironmentIDComponentsPost().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['dispatchOption'] != null) {
      queryParameters['dispatchOption'] = requestParameters['dispatchOption'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/v3/environments/{environmentID}/components`.replace(
          `{${'environmentID'}}`,
          encodeURIComponent(String(requestParameters['environmentID'])),
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters['components']!.map(
          RequestEnvironmentSpecComponentToJSON,
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseOpCreatedFromJSON(jsonValue),
    );
  }

  /**
   * Add components to an environment
   * Add components to environment
   */
  async v3EnvironmentsEnvironmentIDComponentsPost(
    requestParameters: V3EnvironmentsEnvironmentIDComponentsPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseOpCreated | null | undefined> {
    const response = await this.v3EnvironmentsEnvironmentIDComponentsPostRaw(
      requestParameters,
      initOverrides,
    );
    switch (response.raw.status) {
      case 200:
        return await response.value();
      case 204:
        return null;
      default:
        return await response.value();
    }
  }

  /**
   * Get an environment configuration based on an existing environment
   * Get a config based on an environment
   */
  async v3EnvironmentsEnvironmentIDConfigGetRaw(
    requestParameters: V3EnvironmentsEnvironmentIDConfigGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseEnvironmentConfig>> {
    if (requestParameters['environmentID'] == null) {
      throw new runtime.RequiredError(
        'environmentID',
        'Required parameter "environmentID" was null or undefined when calling v3EnvironmentsEnvironmentIDConfigGet().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['stripIdentifiers'] != null) {
      queryParameters['strip_identifiers'] =
        requestParameters['stripIdentifiers'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/v3/environments/{environmentID}/config`.replace(
          `{${'environmentID'}}`,
          encodeURIComponent(String(requestParameters['environmentID'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseEnvironmentConfigFromJSON(jsonValue),
    );
  }

  /**
   * Get an environment configuration based on an existing environment
   * Get a config based on an environment
   */
  async v3EnvironmentsEnvironmentIDConfigGet(
    requestParameters: V3EnvironmentsEnvironmentIDConfigGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseEnvironmentConfig> {
    const response = await this.v3EnvironmentsEnvironmentIDConfigGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Delete an environment
   * Delete environment
   */
  async v3EnvironmentsEnvironmentIDDeleteRaw(
    requestParameters: V3EnvironmentsEnvironmentIDDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseOpCreated>> {
    if (requestParameters['environmentID'] == null) {
      throw new runtime.RequiredError(
        'environmentID',
        'Required parameter "environmentID" was null or undefined when calling v3EnvironmentsEnvironmentIDDelete().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['dispatchOption'] != null) {
      queryParameters['dispatchOption'] = requestParameters['dispatchOption'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/v3/environments/{environmentID}`.replace(
          `{${'environmentID'}}`,
          encodeURIComponent(String(requestParameters['environmentID'])),
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseOpCreatedFromJSON(jsonValue),
    );
  }

  /**
   * Delete an environment
   * Delete environment
   */
  async v3EnvironmentsEnvironmentIDDelete(
    requestParameters: V3EnvironmentsEnvironmentIDDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseOpCreated | null | undefined> {
    const response = await this.v3EnvironmentsEnvironmentIDDeleteRaw(
      requestParameters,
      initOverrides,
    );
    switch (response.raw.status) {
      case 200:
        return await response.value();
      case 204:
        return null;
      default:
        return await response.value();
    }
  }

  /**
   * Add event to an environment. This endpoint is intended for cli\'s/components that are performing actions against an environment, but not necessarily via GitHub Actions (like operations). For example, the Kube-Workload-Autoscaler should send events to the API when it scales-up and scales-down (but a GitHub Actions Pipeline that. calls the Kube-Workload-Autoscaler would also end an Operation).
   * Add event to environment
   */
  async v3EnvironmentsEnvironmentIDEventsPostRaw(
    requestParameters: V3EnvironmentsEnvironmentIDEventsPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['environmentID'] == null) {
      throw new runtime.RequiredError(
        'environmentID',
        'Required parameter "environmentID" was null or undefined when calling v3EnvironmentsEnvironmentIDEventsPost().',
      );
    }

    if (requestParameters['owners'] == null) {
      throw new runtime.RequiredError(
        'owners',
        'Required parameter "owners" was null or undefined when calling v3EnvironmentsEnvironmentIDEventsPost().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/v3/environments/{environmentID}/events`.replace(
          `{${'environmentID'}}`,
          encodeURIComponent(String(requestParameters['environmentID'])),
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: RequestEnvironmentEventToJSON(requestParameters['owners']),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Add event to an environment. This endpoint is intended for cli\'s/components that are performing actions against an environment, but not necessarily via GitHub Actions (like operations). For example, the Kube-Workload-Autoscaler should send events to the API when it scales-up and scales-down (but a GitHub Actions Pipeline that. calls the Kube-Workload-Autoscaler would also end an Operation).
   * Add event to environment
   */
  async v3EnvironmentsEnvironmentIDEventsPost(
    requestParameters: V3EnvironmentsEnvironmentIDEventsPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.v3EnvironmentsEnvironmentIDEventsPostRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   * Get an environment
   * Get an environment
   */
  async v3EnvironmentsEnvironmentIDGetRaw(
    requestParameters: V3EnvironmentsEnvironmentIDGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseEnvironment>> {
    if (requestParameters['environmentID'] == null) {
      throw new runtime.RequiredError(
        'environmentID',
        'Required parameter "environmentID" was null or undefined when calling v3EnvironmentsEnvironmentIDGet().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['includeStatusHistory'] != null) {
      queryParameters['include_status_history'] =
        requestParameters['includeStatusHistory'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/v3/environments/{environmentID}`.replace(
          `{${'environmentID'}}`,
          encodeURIComponent(String(requestParameters['environmentID'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseEnvironmentFromJSON(jsonValue),
    );
  }

  /**
   * Get an environment
   * Get an environment
   */
  async v3EnvironmentsEnvironmentIDGet(
    requestParameters: V3EnvironmentsEnvironmentIDGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseEnvironment> {
    const response = await this.v3EnvironmentsEnvironmentIDGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Get an environment operation
   * Get an environment operation
   */
  async v3EnvironmentsEnvironmentIDOperationsOperationIDGetRaw(
    requestParameters: V3EnvironmentsEnvironmentIDOperationsOperationIDGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseEnvironmentStatusOperation>> {
    if (requestParameters['environmentID'] == null) {
      throw new runtime.RequiredError(
        'environmentID',
        'Required parameter "environmentID" was null or undefined when calling v3EnvironmentsEnvironmentIDOperationsOperationIDGet().',
      );
    }

    if (requestParameters['operationID'] == null) {
      throw new runtime.RequiredError(
        'operationID',
        'Required parameter "operationID" was null or undefined when calling v3EnvironmentsEnvironmentIDOperationsOperationIDGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/v3/environments/{environmentID}/operations/{operationID}`
          .replace(
            `{${'environmentID'}}`,
            encodeURIComponent(String(requestParameters['environmentID'])),
          )
          .replace(
            `{${'operationID'}}`,
            encodeURIComponent(String(requestParameters['operationID'])),
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseEnvironmentStatusOperationFromJSON(jsonValue),
    );
  }

  /**
   * Get an environment operation
   * Get an environment operation
   */
  async v3EnvironmentsEnvironmentIDOperationsOperationIDGet(
    requestParameters: V3EnvironmentsEnvironmentIDOperationsOperationIDGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseEnvironmentStatusOperation> {
    const response =
      await this.v3EnvironmentsEnvironmentIDOperationsOperationIDGetRaw(
        requestParameters,
        initOverrides,
      );
    return await response.value();
  }

  /**
   * Update operation for a given environment
   * Update operation
   */
  async v3EnvironmentsEnvironmentIDOperationsOperationIDPutRaw(
    requestParameters: V3EnvironmentsEnvironmentIDOperationsOperationIDPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['environmentID'] == null) {
      throw new runtime.RequiredError(
        'environmentID',
        'Required parameter "environmentID" was null or undefined when calling v3EnvironmentsEnvironmentIDOperationsOperationIDPut().',
      );
    }

    if (requestParameters['operationID'] == null) {
      throw new runtime.RequiredError(
        'operationID',
        'Required parameter "operationID" was null or undefined when calling v3EnvironmentsEnvironmentIDOperationsOperationIDPut().',
      );
    }

    if (requestParameters['owners'] == null) {
      throw new runtime.RequiredError(
        'owners',
        'Required parameter "owners" was null or undefined when calling v3EnvironmentsEnvironmentIDOperationsOperationIDPut().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/v3/environments/{environmentID}/operations/{operationID}`
          .replace(
            `{${'environmentID'}}`,
            encodeURIComponent(String(requestParameters['environmentID'])),
          )
          .replace(
            `{${'operationID'}}`,
            encodeURIComponent(String(requestParameters['operationID'])),
          ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: RequestEnvironmentOperationToJSON(requestParameters['owners']),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Update operation for a given environment
   * Update operation
   */
  async v3EnvironmentsEnvironmentIDOperationsOperationIDPut(
    requestParameters: V3EnvironmentsEnvironmentIDOperationsOperationIDPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.v3EnvironmentsEnvironmentIDOperationsOperationIDPutRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   * Remove an owner from an environment
   * Remove an owner from an environment
   */
  async v3EnvironmentsEnvironmentIDOwnersOwnerRefIDDeleteRaw(
    requestParameters: V3EnvironmentsEnvironmentIDOwnersOwnerRefIDDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['environmentID'] == null) {
      throw new runtime.RequiredError(
        'environmentID',
        'Required parameter "environmentID" was null or undefined when calling v3EnvironmentsEnvironmentIDOwnersOwnerRefIDDelete().',
      );
    }

    if (requestParameters['ownerRefID'] == null) {
      throw new runtime.RequiredError(
        'ownerRefID',
        'Required parameter "ownerRefID" was null or undefined when calling v3EnvironmentsEnvironmentIDOwnersOwnerRefIDDelete().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/v3/environments/{environmentID}/owners/{ownerRefID}`
          .replace(
            `{${'environmentID'}}`,
            encodeURIComponent(String(requestParameters['environmentID'])),
          )
          .replace(
            `{${'ownerRefID'}}`,
            encodeURIComponent(String(requestParameters['ownerRefID'])),
          ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Remove an owner from an environment
   * Remove an owner from an environment
   */
  async v3EnvironmentsEnvironmentIDOwnersOwnerRefIDDelete(
    requestParameters: V3EnvironmentsEnvironmentIDOwnersOwnerRefIDDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.v3EnvironmentsEnvironmentIDOwnersOwnerRefIDDeleteRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   * Add owners to an environment
   * Add owners to environment
   */
  async v3EnvironmentsEnvironmentIDOwnersPostRaw(
    requestParameters: V3EnvironmentsEnvironmentIDOwnersPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['environmentID'] == null) {
      throw new runtime.RequiredError(
        'environmentID',
        'Required parameter "environmentID" was null or undefined when calling v3EnvironmentsEnvironmentIDOwnersPost().',
      );
    }

    if (requestParameters['owners'] == null) {
      throw new runtime.RequiredError(
        'owners',
        'Required parameter "owners" was null or undefined when calling v3EnvironmentsEnvironmentIDOwnersPost().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/v3/environments/{environmentID}/owners`.replace(
          `{${'environmentID'}}`,
          encodeURIComponent(String(requestParameters['environmentID'])),
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters['owners']!.map(RequestOwnerIdentifierToJSON),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Add owners to an environment
   * Add owners to environment
   */
  async v3EnvironmentsEnvironmentIDOwnersPost(
    requestParameters: V3EnvironmentsEnvironmentIDOwnersPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.v3EnvironmentsEnvironmentIDOwnersPostRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   * Replace all owners of an environment with the provided list
   * Replace all owners of an environment
   */
  async v3EnvironmentsEnvironmentIDOwnersPutRaw(
    requestParameters: V3EnvironmentsEnvironmentIDOwnersPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['environmentID'] == null) {
      throw new runtime.RequiredError(
        'environmentID',
        'Required parameter "environmentID" was null or undefined when calling v3EnvironmentsEnvironmentIDOwnersPut().',
      );
    }

    if (requestParameters['owners'] == null) {
      throw new runtime.RequiredError(
        'owners',
        'Required parameter "owners" was null or undefined when calling v3EnvironmentsEnvironmentIDOwnersPut().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/v3/environments/{environmentID}/owners`.replace(
          `{${'environmentID'}}`,
          encodeURIComponent(String(requestParameters['environmentID'])),
        ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters['owners']!.map(RequestOwnerIdentifierToJSON),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Replace all owners of an environment with the provided list
   * Replace all owners of an environment
   */
  async v3EnvironmentsEnvironmentIDOwnersPut(
    requestParameters: V3EnvironmentsEnvironmentIDOwnersPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.v3EnvironmentsEnvironmentIDOwnersPutRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   * Updates an environment
   * Update environment
   */
  async v3EnvironmentsEnvironmentIDPutRaw(
    requestParameters: V3EnvironmentsEnvironmentIDPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseDiffReport>> {
    if (requestParameters['environmentID'] == null) {
      throw new runtime.RequiredError(
        'environmentID',
        'Required parameter "environmentID" was null or undefined when calling v3EnvironmentsEnvironmentIDPut().',
      );
    }

    if (requestParameters['environment'] == null) {
      throw new runtime.RequiredError(
        'environment',
        'Required parameter "environment" was null or undefined when calling v3EnvironmentsEnvironmentIDPut().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['dispatchOption'] != null) {
      queryParameters['dispatchOption'] = requestParameters['dispatchOption'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/v3/environments/{environmentID}`.replace(
          `{${'environmentID'}}`,
          encodeURIComponent(String(requestParameters['environmentID'])),
        ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: RequestEnvironmentToJSON(requestParameters['environment']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseDiffReportFromJSON(jsonValue),
    );
  }

  /**
   * Updates an environment
   * Update environment
   */
  async v3EnvironmentsEnvironmentIDPut(
    requestParameters: V3EnvironmentsEnvironmentIDPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseDiffReport | null | undefined> {
    const response = await this.v3EnvironmentsEnvironmentIDPutRaw(
      requestParameters,
      initOverrides,
    );
    switch (response.raw.status) {
      case 200:
        return await response.value();
      case 204:
        return null;
      default:
        return await response.value();
    }
  }

  /**
   * Scale down an environment and all the subsequent clusters within the environment
   * Scale down an environment
   */
  async v3EnvironmentsEnvironmentIDScaleDownPostRaw(
    requestParameters: V3EnvironmentsEnvironmentIDScaleDownPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseOpCreated>> {
    if (requestParameters['environmentID'] == null) {
      throw new runtime.RequiredError(
        'environmentID',
        'Required parameter "environmentID" was null or undefined when calling v3EnvironmentsEnvironmentIDScaleDownPost().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/v3/environments/{environmentID}/scale-down`.replace(
          `{${'environmentID'}}`,
          encodeURIComponent(String(requestParameters['environmentID'])),
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseOpCreatedFromJSON(jsonValue),
    );
  }

  /**
   * Scale down an environment and all the subsequent clusters within the environment
   * Scale down an environment
   */
  async v3EnvironmentsEnvironmentIDScaleDownPost(
    requestParameters: V3EnvironmentsEnvironmentIDScaleDownPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseOpCreated | null | undefined> {
    const response = await this.v3EnvironmentsEnvironmentIDScaleDownPostRaw(
      requestParameters,
      initOverrides,
    );
    switch (response.raw.status) {
      case 200:
        return await response.value();
      case 204:
        return null;
      default:
        return await response.value();
    }
  }

  /**
   * Scale up an environment and all the subsequent clusters within the environment
   * Scale up an environment
   */
  async v3EnvironmentsEnvironmentIDScaleUpPostRaw(
    requestParameters: V3EnvironmentsEnvironmentIDScaleUpPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseOpCreated>> {
    if (requestParameters['environmentID'] == null) {
      throw new runtime.RequiredError(
        'environmentID',
        'Required parameter "environmentID" was null or undefined when calling v3EnvironmentsEnvironmentIDScaleUpPost().',
      );
    }

    if (requestParameters['duration'] == null) {
      throw new runtime.RequiredError(
        'duration',
        'Required parameter "duration" was null or undefined when calling v3EnvironmentsEnvironmentIDScaleUpPost().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/v3/environments/{environmentID}/scale-up`.replace(
          `{${'environmentID'}}`,
          encodeURIComponent(String(requestParameters['environmentID'])),
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: RequestScaleUpToJSON(requestParameters['duration']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseOpCreatedFromJSON(jsonValue),
    );
  }

  /**
   * Scale up an environment and all the subsequent clusters within the environment
   * Scale up an environment
   */
  async v3EnvironmentsEnvironmentIDScaleUpPost(
    requestParameters: V3EnvironmentsEnvironmentIDScaleUpPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseOpCreated | null | undefined> {
    const response = await this.v3EnvironmentsEnvironmentIDScaleUpPostRaw(
      requestParameters,
      initOverrides,
    );
    switch (response.raw.status) {
      case 200:
        return await response.value();
      case 204:
        return null;
      default:
        return await response.value();
    }
  }

  /**
   * Triggers a new update of the entire existing environment
   * Trigger an update operation on an environment
   */
  async v3EnvironmentsEnvironmentIDUpdatePostRaw(
    requestParameters: V3EnvironmentsEnvironmentIDUpdatePostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseOpCreated>> {
    if (requestParameters['environmentID'] == null) {
      throw new runtime.RequiredError(
        'environmentID',
        'Required parameter "environmentID" was null or undefined when calling v3EnvironmentsEnvironmentIDUpdatePost().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['dispatchOption'] != null) {
      queryParameters['dispatchOption'] = requestParameters['dispatchOption'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/v3/environments/{environmentID}/update`.replace(
          `{${'environmentID'}}`,
          encodeURIComponent(String(requestParameters['environmentID'])),
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseOpCreatedFromJSON(jsonValue),
    );
  }

  /**
   * Triggers a new update of the entire existing environment
   * Trigger an update operation on an environment
   */
  async v3EnvironmentsEnvironmentIDUpdatePost(
    requestParameters: V3EnvironmentsEnvironmentIDUpdatePostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseOpCreated | null | undefined> {
    const response = await this.v3EnvironmentsEnvironmentIDUpdatePostRaw(
      requestParameters,
      initOverrides,
    );
    switch (response.raw.status) {
      case 200:
        return await response.value();
      case 204:
        return null;
      default:
        return await response.value();
    }
  }

  /**
   * List environments
   * List environments
   */
  async v3EnvironmentsGetRaw(
    requestParameters: V3EnvironmentsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseEnvironmentList>> {
    const queryParameters: any = {};

    if (requestParameters['searchTerm'] != null) {
      queryParameters['search_term'] = requestParameters['searchTerm'];
    }

    if (requestParameters['ownerIdentifier'] != null) {
      queryParameters['owner_identifier'] =
        requestParameters['ownerIdentifier'];
    }

    if (requestParameters['includeDeleted'] != null) {
      queryParameters['include_deleted'] = requestParameters['includeDeleted'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/v3/environments`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseEnvironmentListFromJSON(jsonValue),
    );
  }

  /**
   * List environments
   * List environments
   */
  async v3EnvironmentsGet(
    requestParameters: V3EnvironmentsGetRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseEnvironmentList> {
    const response = await this.v3EnvironmentsGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Get an environment ID by name
   * Get an environment ID by name
   */
  async v3EnvironmentsIdByNameEnvironmentNameGetRaw(
    requestParameters: V3EnvironmentsIdByNameEnvironmentNameGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<string>> {
    if (requestParameters['environmentName'] == null) {
      throw new runtime.RequiredError(
        'environmentName',
        'Required parameter "environmentName" was null or undefined when calling v3EnvironmentsIdByNameEnvironmentNameGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/v3/environments/id-by-name/{environmentName}`.replace(
          `{${'environmentName'}}`,
          encodeURIComponent(String(requestParameters['environmentName'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    if (this.isJsonMime(response.headers.get('content-type'))) {
      return new runtime.JSONApiResponse<string>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * Get an environment ID by name
   * Get an environment ID by name
   */
  async v3EnvironmentsIdByNameEnvironmentNameGet(
    requestParameters: V3EnvironmentsIdByNameEnvironmentNameGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<string> {
    const response = await this.v3EnvironmentsIdByNameEnvironmentNameGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * List environment names
   * List environment names
   */
  async v3EnvironmentsNamesGetRaw(
    requestParameters: V3EnvironmentsNamesGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<string>>> {
    const queryParameters: any = {};

    if (requestParameters['searchTerm'] != null) {
      queryParameters['search_term'] = requestParameters['searchTerm'];
    }

    if (requestParameters['ownerIdentifier'] != null) {
      queryParameters['owner_identifier'] =
        requestParameters['ownerIdentifier'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/v3/environments/names`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * List environment names
   * List environment names
   */
  async v3EnvironmentsNamesGet(
    requestParameters: V3EnvironmentsNamesGetRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<string>> {
    const response = await this.v3EnvironmentsNamesGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Create a new environment
   * Create environment
   */
  async v3EnvironmentsPostRaw(
    requestParameters: V3EnvironmentsPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseEnvironmentCreated>> {
    if (requestParameters['environment'] == null) {
      throw new runtime.RequiredError(
        'environment',
        'Required parameter "environment" was null or undefined when calling v3EnvironmentsPost().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['dispatchOption'] != null) {
      queryParameters['dispatchOption'] = requestParameters['dispatchOption'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/v3/environments`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: RequestEnvironmentToJSON(requestParameters['environment']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseEnvironmentCreatedFromJSON(jsonValue),
    );
  }

  /**
   * Create a new environment
   * Create environment
   */
  async v3EnvironmentsPost(
    requestParameters: V3EnvironmentsPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseEnvironmentCreated> {
    const response = await this.v3EnvironmentsPostRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}

/**
 * @export
 */
export const V3EnvironmentsEnvironmentIDClustersPostDispatchOptionEnum = {
  None: 'NONE',
  Full: 'FULL',
  DryRun: 'DRY_RUN',
} as const;
export type V3EnvironmentsEnvironmentIDClustersPostDispatchOptionEnum =
  (typeof V3EnvironmentsEnvironmentIDClustersPostDispatchOptionEnum)[keyof typeof V3EnvironmentsEnvironmentIDClustersPostDispatchOptionEnum];
/**
 * @export
 */
export const V3EnvironmentsEnvironmentIDComponentsPostDispatchOptionEnum = {
  None: 'NONE',
  Full: 'FULL',
  DryRun: 'DRY_RUN',
} as const;
export type V3EnvironmentsEnvironmentIDComponentsPostDispatchOptionEnum =
  (typeof V3EnvironmentsEnvironmentIDComponentsPostDispatchOptionEnum)[keyof typeof V3EnvironmentsEnvironmentIDComponentsPostDispatchOptionEnum];
/**
 * @export
 */
export const V3EnvironmentsEnvironmentIDDeleteDispatchOptionEnum = {
  None: 'NONE',
  Full: 'FULL',
  DryRun: 'DRY_RUN',
} as const;
export type V3EnvironmentsEnvironmentIDDeleteDispatchOptionEnum =
  (typeof V3EnvironmentsEnvironmentIDDeleteDispatchOptionEnum)[keyof typeof V3EnvironmentsEnvironmentIDDeleteDispatchOptionEnum];
/**
 * @export
 */
export const V3EnvironmentsEnvironmentIDPutDispatchOptionEnum = {
  None: 'NONE',
  Full: 'FULL',
  DryRun: 'DRY_RUN',
} as const;
export type V3EnvironmentsEnvironmentIDPutDispatchOptionEnum =
  (typeof V3EnvironmentsEnvironmentIDPutDispatchOptionEnum)[keyof typeof V3EnvironmentsEnvironmentIDPutDispatchOptionEnum];
/**
 * @export
 */
export const V3EnvironmentsEnvironmentIDUpdatePostDispatchOptionEnum = {
  None: 'NONE',
  Full: 'FULL',
  DryRun: 'DRY_RUN',
} as const;
export type V3EnvironmentsEnvironmentIDUpdatePostDispatchOptionEnum =
  (typeof V3EnvironmentsEnvironmentIDUpdatePostDispatchOptionEnum)[keyof typeof V3EnvironmentsEnvironmentIDUpdatePostDispatchOptionEnum];
/**
 * @export
 */
export const V3EnvironmentsPostDispatchOptionEnum = {
  None: 'NONE',
  Full: 'FULL',
  DryRun: 'DRY_RUN',
} as const;
export type V3EnvironmentsPostDispatchOptionEnum =
  (typeof V3EnvironmentsPostDispatchOptionEnum)[keyof typeof V3EnvironmentsPostDispatchOptionEnum];
